<template>
    <div class="inline-block w-full" id="top">
        <Breadcrumb :current="4" />

        <div id="header-pdf" class="display-none mb-[80px]">
            <div class="flex justify-between mb-[40px]">
                <img src="../../../public/icon/logo_mobile.png" alt="Motornet" class="logo" />

                <div class="self-center text-xl">
                    Data generazione: <b>{{ new Date().toLocaleDateString('it-IT') }}</b>
                </div>
            </div>
            <h2 class="text-4xl font-bold">Valore previsionale - Forecast</h2>
        </div>

        <div id="ImgAndChart">
            <div class="flex items-center bg-[#e96932] rounded-t-[8px] py-[15px] px-[20px]">
                <h4 class="text-[#fff]">{{ allestimento?.marcaNome }} {{
                    allestimento?.versione }}
                </h4>
            </div>

            <div
                class="bg-[#fff] flex justify-center items-center w-full h-[350px] border border-[#e96932] rounded-b-[8px]">
                <img v-if="foto?.length > 0" :src="foto[0]?.url"
                    class="max-h-full relative text-black rounded-b-[8px] p-[10px]" :alt="allestimento?.versione">
            </div>

            <div class="my-[40px]">
                <h3 class="text-[1.5rem] text-center mb-[10px]">Valore €</h3>
                <div id="chart">
                    <Chart :options="chartOptions" :series="chartSeries" type="line" height="350" />
                </div>
            </div>

            <div class="my-[40px]">
                <h3 class="text-[1.5rem] text-center mb-[10px]">% val. residuo</h3>
                <div id="chart">
                    <Chart :options="chartOptionsPerc" :series="chartSeriesPerc" type="line" height="350" />
                </div>
            </div>
        </div>

        <div id="Values">
            <div v-for="(forec, idxF) in forecast?.forecastedValue" :key="idxF"
                class="border border-[#e96932] rounded-[10px] mt-[50px] pb-[10px]">
                <div class="block flex items-center bg-[#e96932] rounded-t-[8px] py-[15px] px-[20px]">
                    <div class="flex justify-between items-center w-full">
                        <h4 class="text-[#fff]">Forecast a: {{ forec?.forecastPeriod }} mesi</h4>
                        <!--<div class="flex justify-end">
                        <button title="Invia tramite email" class="button ml-[8px] py-[5px] px-[10px]">
                            <font-awesome-icon icon="fa-solid fa-envelope" />
                        </button>
                    </div>-->
                    </div>
                </div>

                <div class="flex justify-between mt-[10px] px-[10px]">
                    <div class="w-[49%] text-center border border-[#166fff] rounded-[10px]">
                        <h4 class="text-[1rem] text-center text-[#fff] bg-[#166fff] rounded-t-[8px] p-[10px]">
                            RITIRO</h4>
                        <div class="flex flex-col sm:flex-row justify-center items-center gap-[5px] py-[10px]">
                            <div>
                                <div class="flex items-center justify-center">
                                    <h3 v-if="formatNumber(forec?.tradeAmount) > 0" class="text-[1.5rem] mb-0">€
                                    </h3>
                                    <h3 class="text-[1.5rem] pl-[10px] mb-0">{{
                                        formatNumber(forec?.tradeAmount) }}</h3>
                                </div>
                            </div>
                        </div>
                        <hr v-if="forec?.tradeValueInPercentage > 0" class="w-[60%] justify-self-center opacity-40"
                            style="border: 1px solid #166fff" />
                        <p v-if="forec?.tradeValueInPercentage > 0" class="text-[1rem] py-[10px]">% val.
                            residuo:
                            <span class="text-[1.25rem] font-bold mb-0">{{
                                formatPercentage(forec?.tradeValueInPercentage) }} %</span>
                        </p>
                    </div>

                    <div class="w-[49%] text-center border border-[#fce54e] rounded-[10px]">
                        <h4 class="text-[1rem] text-center text-[#000] bg-[#fce54e] rounded-t-[8px] p-[10px]">
                            VENDITA</h4>
                        <div class="py-[10px] px-[20px]">
                            <div class="flex items-center justify-center">
                                <h3 v-if="formatNumber(forec?.retailAmount) > 0" class="text-[1.5rem] mb-0">€
                                </h3>
                                <h3 class="text-[1.5rem] pl-[10px] mb-0">{{ formatNumber(forec?.retailAmount)
                                }}</h3>
                            </div>
                        </div>
                        <hr v-if="forec?.retailValueInPercentage > 0" class="w-[60%] justify-self-center opacity-40"
                            style="border: 1px solid #fce54e" />
                        <p v-if="forec?.retailValueInPercentage > 0" class="text-[1rem] py-[10px]">% val.
                            residuo:
                            <span class="text-[1.25rem] font-bold mb-0">{{
                                formatPercentage(forec?.retailValueInPercentage) }} %</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end gap-[10px] mt-[60px]">
            <div v-if="forecast?.forecastedValue?.length > 1" class="flex justify-end cursor-pointer">
                <div class="button py-[5px] px-[10px]" @click="handleDownloadPdf">
                    <font-awesome-icon icon="fa-solid fa-file-pdf" class="h-[20px]" />
                </div>
            </div>

            <div v-if="forecast?.forecastedValue?.length > 1" class="flex justify-end cursor-pointer">
                <div class="button py-[5px] px-[10px]" @click="goUp">
                    <label class="mr-[5px]">Torna su</label>
                    <font-awesome-icon icon="fa-solid fa-arrow-up" class="h-[20px]" />
                </div>
            </div>
        </div>
    </div>
    <div v-if="isDownloading"
        class="absolute bg-[rgba(255,255,255,0.85)] flex items-center z-9999 flex-col gap-1 pt-[35%] text-center"
        style="inset: 0">
        <div class="flex items-center gap-[12px]">
            <div class="w-[48px] h-[48px] rounded-3xl"
                style="border: 4px solid #ccc; border-top-color: #0b76ef; animation: spin 1s linear infinite"></div>
            <div>
                <div class="text-base font-semibold">Sto generando il PDF</div>
                <div class="text-sm color: '#666'">{{ statusMessage }}</div>
            </div>
        </div>

        <div class="w-[60%] max-w-[400px]">
            <div class="h-[8px] bg-[#eee] rounded-sm overflow-hidden">
                <div class="h-full bg-[#0b76ef] ease-[300ms]" :style="`width: ${progress}%`"></div>
            </div>
            <div class="mt-[8px] text-sm text-[#444]">{{ progress }}%</div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from './Breadcrumb.vue';
import { mainStore } from '../../../store/main';
import axios from 'axios';
import formatter from "../../formatter";
import { defineAsyncComponent } from 'vue';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default {
    name: 'ForecastView',
    components: { Breadcrumb, Chart: defineAsyncComponent(() => import('vue3-apexcharts')) },

    data() {
        return {
            mainStore,
            forecast: {},
            allestimento: {},
            foto: {},
            chartSeries: [],
            chartOptions: {},
            chartSeriesPerc: [],
            chartOptionsPerc: {},
            isDownloading: false,
            progress: 0,
            statusMessage: '',
            config: [
                { selector: '#ImgAndChart', newPageBefore: false },
                { selector: '#Values', newPageBefore: true },
            ],
        }
    },

    async created() {
        const loader = this.$loading.show();

        this.forecast = { ...this.mainStore?.forecast };
        this.allestimento = { ...this.mainStore?.allestimentoVeicolo };

        this.foto = await this.getFoto();

        this.initChart();
        this.initChartPerc();

        loader.hide();
    },

    methods: {
        async waitForVFor(selector, expectedCount, timeout = 2500) {
            const start = performance.now();
            return new Promise((resolve) => {
                const check = () => {
                    const count = document.querySelectorAll(selector).length;
                    if (count === expectedCount) {
                        resolve();
                        return;
                    }
                    if (performance.now() - start > timeout) {
                        resolve();
                        return;
                    }
                    requestAnimationFrame(check);
                };
                check();
            });
        },

        async handleDownloadPdf() {
            try {
                window.scrollTo({ top: 0, behavior: 'auto' });

                await new Promise((resolve) => {
                    requestAnimationFrame(() => requestAnimationFrame(resolve));
                });

                this.isDownloading = true;
                this.progress = 2;
                this.statusMessage = 'Preparazione PDF...';

                // PDF A4
                const pdf = new jsPDF({
                    format: 'a4',
                    orientation: 'p',
                    unit: 'mm'
                });

                const margin = 10;
                const scale = 2;

                const pageWidthMm = pdf.internal.pageSize.getWidth() - margin * 2;
                const pageHeightMm = pdf.internal.pageSize.getHeight() - margin * 2;

                // Larghezza massima del contenuto HTML
                const maxPagePx = 520;

                // Conversione px → mm basata su 520px
                const pxToMmRatio = pageWidthMm / (maxPagePx * scale);

                // Larghezza effettiva del contenuto nel PDF
                const contentWidthMm = maxPagePx * pxToMmRatio;

                // Offset per centrare il contenuto
                const horizontalOffset = margin + (pageWidthMm - contentWidthMm) / 2;

                // ---------------- HEADER ----------------
                this.statusMessage = 'Cattura header...';

                const headerEl = document.querySelector('#header-pdf');
                let headerImgData = null;
                let headerHeightMm = 0;

                if (headerEl) {
                    headerEl.classList.remove('display-none');
                    headerEl.classList.add('header-padding-fix');

                    await new Promise(r => requestAnimationFrame(r));
                    await new Promise(r => requestAnimationFrame(r));

                    const headerCanvas = await html2canvas(headerEl, { scale, useCORS: true });
                    headerImgData = headerCanvas.toDataURL('image/png');
                    headerEl.classList.remove('header-padding-fix');

                    const headerPxToMm = contentWidthMm / headerCanvas.width;
                    headerHeightMm = headerCanvas.height * headerPxToMm;
                    headerEl.classList.add('display-none');

                }

                this.progress = 10;
                this.statusMessage = 'Calcolo pagine...';

                const contentHeightMm = pageHeightMm - headerHeightMm;
                const segHeightPx = contentHeightMm / pxToMmRatio;

                const addHeader = () => {
                    if (!headerImgData) return;

                    pdf.addImage(
                        headerImgData,
                        'PNG',
                        horizontalOffset,
                        margin,
                        contentWidthMm,
                        headerHeightMm
                    );
                };

                // ---------------- CONTENUTO ----------------
                for (let i = 0; i < this.config.length; i++) {
                    const { selector, newPageBefore } = this.config[i];
                    const el = document.querySelector(selector);
                    if (!el) continue;

                    this.statusMessage = `Cattura sezione ${i + 1}/${this.config.length}...`;

                    if (i === 0) {
                        addHeader();
                    } else if (newPageBefore) {
                        pdf.addPage();
                        addHeader();
                    }

                    await this.waitForVFor(
                        '#Values',
                        this.forecast?.forecastedValue.length
                    );

                    await this.$nextTick();
                    await new Promise(r => requestAnimationFrame(r));
                    await new Promise(r => requestAnimationFrame(r));

                    const canvas = await html2canvas(el, {
                        scale,
                        useCORS: true,
                        onclone: (clonedDoc) => {
                            const style = document.querySelector('link[href*="tailwind"]');
                            if (style) clonedDoc.head.appendChild(style.cloneNode(true));
                        }
                    });

                    const imgData = canvas.toDataURL('image/png');
                    const imgHmm = (canvas.height * contentWidthMm) / canvas.width;

                    // ---------------- SLICING ----------------
                    if (imgHmm > contentHeightMm) {
                        let remPx = canvas.height;
                        let offsetYpx = 0;

                        while (remPx > 0) {
                            const slicePx = Math.min(segHeightPx, remPx);
                            if (slicePx <= 0) break;

                            const sliceCanv = document.createElement('canvas');
                            sliceCanv.width = canvas.width;
                            sliceCanv.height = slicePx;

                            sliceCanv.getContext('2d')
                                ?.drawImage(canvas, 0, offsetYpx, canvas.width, slicePx, 0, 0, canvas.width, slicePx);

                            const sliceData = sliceCanv.toDataURL('image/png');
                            const sliceHmm = Math.max(0.1, slicePx * pxToMmRatio);

                            pdf.addImage(
                                sliceData,
                                'PNG',
                                horizontalOffset,
                                margin + headerHeightMm,
                                contentWidthMm,
                                sliceHmm
                            );

                            remPx -= slicePx;
                            offsetYpx += slicePx;

                            if (remPx > 0) {
                                pdf.addPage();
                                addHeader();
                            }
                        }
                    } else {
                        pdf.addImage(
                            imgData,
                            'PNG',
                            horizontalOffset,
                            margin + headerHeightMm,
                            contentWidthMm,
                            imgHmm
                        );
                    }

                    this.progress = 50;
                }

                // ---------------- FOOTER ----------------
                this.statusMessage = 'Aggiunta numerazione...';

                const totalPages = pdf.getNumberOfPages();
                pdf.setFontSize(10);

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.text(
                        `Pagina ${i} di ${totalPages}`,
                        pdf.internal.pageSize.getWidth() / 2,
                        pdf.internal.pageSize.getHeight() - 5,
                        { align: 'center' }
                    );
                }

                this.progress = 80;
                this.statusMessage = 'Salvataggio PDF...';

                pdf.save(`Forecast.pdf`);

                this.progress = 100;
                this.statusMessage = 'Completato';

            } catch (err) {
                console.error('Errore generazione PDF', err);
                this.statusMessage = 'Errore durante la generazione del PDF';
            } finally {
                setTimeout(() => {
                    this.isDownloading = false;
                    this.progress = 0;
                    this.statusMessage = '';
                }, 500);
            }
        },
        initChart() {
            let min = 9999999999;
            let valBlu = [];
            let categories = [];
            for (let i = 0; i < this.forecast?.forecastedValue?.length; i++) {
                const val = this.forecast?.forecastedValue[i];
                if (val && val?.tradeAmount && val.tradeAmount < min) {
                    min = val?.tradeAmount;
                }

                valBlu.push(val?.tradeAmount ?? null);

                const mese = val?.forecastPeriod || ' ';

                categories.push(`${mese} mesi`);
            }

            let max = 0;
            let valGiallo = [];
            for (let i = 0; i < this.forecast?.forecastedValue?.length; i++) {
                const val = this.forecast?.forecastedValue[i];
                if (val && val?.retailAmount && val.retailAmount > max) {
                    max = val?.retailAmount;
                }

                valGiallo.push(val?.retailAmount ?? null);
            }

            min -= 1000;
            max += 1000;

            const series = [
                {
                    name: 'Ritiro',
                    data: valBlu,
                },
                {
                    name: 'Vendita',
                    data: valGiallo,
                }
            ];

            this.chartSeries = series;

            this.chartOptions = {
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false,
                    },
                    toolbar: {
                        show: true,
                    },
                },
                xaxis: {
                    categories,
                },
                yaxis: {
                    min,
                    max,
                    show: false,
                },
                stroke: {
                    curve: 'straight',
                },
                colors: ['#009ee3', '#fe0'],
                legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                    floating: true,
                },
                markers: {
                    size: 3,
                    colors: ['#2B2D2D'],
                    strokeColors: ['#2B2D2D'],
                    hover: {
                        size: 5,
                    },
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ['#2B2D2D'],
                    },
                    background: {
                        enabled: false,
                    },
                    offsetY: -8,
                },
                grid: {
                    show: true,
                    padding: {
                        left: 40,
                        right: 40,
                    },
                    xaxis: {
                        lines: {
                            show: true,
                        },
                    },
                    yaxis: {
                        lines: {
                            show: false,
                        },
                    },
                },
            };
        },
        initChartPerc() {
            let min = 9999999999;
            let valBlu = [];
            let categories = [];
            for (let i = 0; i < this.forecast?.forecastedValue?.length; i++) {
                const val = this.forecast?.forecastedValue[i];
                if (val && val?.tradeValueInPercentage && val.tradeValueInPercentage < min) {
                    min = val?.tradeValueInPercentage;
                }

                valBlu.push(val?.tradeValueInPercentage ?? null);

                const mese = val?.forecastPeriod || ' ';

                categories.push(`${mese} mesi`);
            }

            let max = 0;
            let valGiallo = [];
            for (let i = 0; i < this.forecast?.forecastedValue?.length; i++) {
                const val = this.forecast?.forecastedValue[i];
                if (val && val?.retailValueInPercentage && val.retailValueInPercentage > max) {
                    max = val?.retailValueInPercentage;
                }

                valGiallo.push(val?.retailValueInPercentage ?? null);
            }

            min -= 10;
            max += 10;

            const series = [
                {
                    name: 'Ritiro',
                    data: valBlu,
                },
                {
                    name: 'Vendita',
                    data: valGiallo,
                }
            ];

            this.chartSeriesPerc = series;

            this.chartOptionsPerc = {
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false,
                    },
                    toolbar: {
                        show: true,
                    },
                },
                xaxis: {
                    categories,
                },
                yaxis: {
                    min,
                    max,
                    show: false,
                },
                stroke: {
                    curve: 'straight',
                },
                colors: ['#009ee3', '#fe0'],
                legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                    floating: true,
                },
                markers: {
                    size: 3,
                    colors: ['#2B2D2D'],
                    strokeColors: ['#2B2D2D'],
                    hover: {
                        size: 5,
                    },
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ['#2B2D2D'],
                    },
                    background: {
                        enabled: false,
                    },
                    offsetY: -8,
                },
                grid: {
                    show: true,
                    padding: {
                        left: 40,
                        right: 40,
                    },
                    xaxis: {
                        lines: {
                            show: true,
                        },
                    },
                    yaxis: {
                        lines: {
                            show: false,
                        },
                    },
                },
            };
        },
        async getFoto() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/${this.mainStore.type}/foto?codice_eurotax=${this.mainStore?.forecast?.codiceEurotax}`)

                return [...response.data?.immagini];
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento della foto",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "warn",
                });
            }
        },
        format(date, initialFormat, finalFormat) {
            if (!date) {
                return null;
            }
            return formatter.formatDate(date, initialFormat, finalFormat);
        },
        goUp() {
            document.getElementById('top').scrollIntoView({ behavior: 'smooth' });
        },
        formatNumber(number) {
            if (number > 0) {
                return Intl.NumberFormat('it-IT', {
                    useGrouping: true,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }).format(number);
            } else {
                return "N.D.";
            }
        },
        formatPercentage(number) {
            if (number > 0) {
                let result = number.toFixed(2);
                return result.replace('.', ',');
            } else {
                return "N.D.";
            }
        },
    },
}
</script>

<style>
.header-padding-fix {
    padding-bottom: 40px !important;
}

.display-none {
    display: none !important;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>